module.exports = __webpack_public_path__ + "original-ideas-icon-12ddf2379df638ee883385f50ca3013a.png";


/*****************
 ** WEBPACK FOOTER
 ** ../app/Components/Benefits/original-ideas-icon.png
 ** module id = 473
 ** module chunks = 0
 **/